import isString from 'lodash/isString'

/**
 * Хелпер динамической загрузки скриптов.
 * @param {string} src Ссылка на скрипт.
 * @param {string} globalVar Глобальная переменная скрипта.
 * @returns {Promise<unknown>|Promise<void>} Промис загрузки скрипта.
 */
export const scriptLoader = (src, globalVar) => {
  if (!isString(src) || !isString(globalVar)) {
    return Promise.reject(Error('Params of scriptLoader() must be filled.'))
  }
  if (globalVar && window[globalVar]) {
    return Promise.resolve(window[globalVar])
  }
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = src
    script.onerror = () => {
      reject(Error(`Error loading "${globalVar || src}"`))
    }
    script.onload = () => {
      if (!globalVar || window[globalVar]) {
        resolve(window[globalVar])
      } else {
        reject(Error(`window.${globalVar} undefined.`))
      }
    }
    try {
      document.head.appendChild(script)
    } catch (e) {
      reject(e)
    }
  })
}
